import { Injectable } from '@angular/core';
import { ConfigService } from '../common/config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MyTripDetailsService {

  constructor(private configServ: ConfigService, private http: HttpClient) { }
  private orderDetails: any;

  setOrderDetails(details: any): void {
    this.orderDetails = details;
  }

  getOrderDetails(): any {
    return this.orderDetails;
  }

  orderRating(data: any) {
    return this.http.post<any>(this.configServ.apiRoutes.ORDER_RATING, data);
  }

  obstacleDetails(data: any) {
    return this.http.post<any>(this.configServ.apiRoutes.OBSTACLE_DETAILS, data);
  }

   orderRatingForHelper(data: any) {
    return this.http.post<any>(this.configServ.apiRoutes.ORDER_RATING_FOR_HELPER, data);
  }

}
